
    import { useState, useEffect, useCallback } from 'react';
    import { useToast } from "@/components/ui/use-toast";

    export const useTermsManagement = (user, profile, loadingProfile, isLoadingSiteSettings, currentTermsVersion, updateUserProfile, refetchProfile) => {
      const [showTermsDialog, setShowTermsDialog] = useState(false);
      const { toast } = useToast();

      const checkTermsAgreement = useCallback(() => {
        if (user && profile && !loadingProfile && !isLoadingSiteSettings && currentTermsVersion) {
          const termsAgreed = profile.terms_agreed;
          const agreedVersion = profile.terms_version_agreed;
          
          const needsToAgree = !termsAgreed || (agreedVersion !== currentTermsVersion);

          if (needsToAgree) {
            setShowTermsDialog(true);
            return false; 
          } else {
            setShowTermsDialog(false);
            return true; 
          }
        } else if (!user && !loadingProfile && !isLoadingSiteSettings) { 
          setShowTermsDialog(false); 
          return true; 
        }
        return undefined; 
      }, [user, profile, loadingProfile, isLoadingSiteSettings, currentTermsVersion, setShowTermsDialog]);

      useEffect(() => {
        checkTermsAgreement();
      }, [checkTermsAgreement]);

      const handleAcceptTerms = useCallback(async () => {
        if (!profile || !currentTermsVersion) {
          console.warn("Cannot accept terms: Profile or currentTermsVersion missing.");
          return;
        }
        try {
          await updateUserProfile({ 
            terms_agreed: true, 
            terms_version_agreed: currentTermsVersion,
            terms_agreed_at: new Date().toISOString()
          });
          setShowTermsDialog(false);
          toast({ title: "Terms Accepted", description: "Thank you for accepting the terms of service." });
          if (refetchProfile) refetchProfile(); 
        } catch (error) {
          toast({ title: "Error", description: "Could not update terms agreement. Please try again.", variant: "destructive" });
        }
      }, [profile, currentTermsVersion, updateUserProfile, toast, refetchProfile]);

      const closeTermsDialog = useCallback(() => {
        setShowTermsDialog(false);
      }, []);

      return {
        showTermsDialog,
        setShowTermsDialog, 
        handleAcceptTerms,
        closeTermsDialog,
        checkTermsAgreement, 
      };
    };
  